module.exports = __webpack_public_path__ + "media/shared/assets/fonts/InterDisplay/InterDisplay-Thin-8869ea180347c0b3e105f1f25d8159c1.woff2";